import * as React from 'react';
var defaultValue = {
    isEmployeeView: false,
    calendarInfo: null,
};
var CalendarViewContext = React.createContext(defaultValue);
var CalendarViewProvider = function (props) {
    var value = {
        isEmployeeView: props.isEmployeeView,
        calendarInfo: props.isEmployeeView ? props.calendarInfo : null,
    };
    return (React.createElement(CalendarViewContext.Provider, { value: value }, props.children));
};
var useCalendarViewContext = function () {
    var context = React.useContext(CalendarViewContext);
    return context;
};
export { CalendarViewProvider, useCalendarViewContext };
